import React from "react";
import { ReactComponent as TitleImage } from "../../../../../assets/svgs/EmployeeWellBeings.svg";
import ThreeColumnBarGraph from "../common/MultipleColumnBarGraph";
import TwoBarHorizontalGraph from "../common/MultipleBarGraph";
import { THEME_COLORS } from "../../../../../color";

const EmployeeWellBeing = ({ getComponent, activeDashboard }) => {
  const comp = getComponent ? getComponent("soc_employee_wellbeing") : null;

  // Default fallback data for dummy
  let chartData = [
    { data: [100, 50] }, // Salaries, Wages & Bonus for Previous Year, Current Year
    { data: [100, 50] }, // Provident & Other Funds for Previous Year, Current Year
    { data: [100, 50] }, // Staff Welfare Expenses for Previous Year, Current Year
  ];
  let chartCategories = ["Previous Year", "Current Year"];
  let chartColors = [
    THEME_COLORS.green,
    THEME_COLORS.yellow,
    THEME_COLORS.darkblue,
  ];
  let chartBarNames = [
    "Salaries, Wages & Bonus",
    "Provident & Other Funds",
    "Staff Welfare Expenses",
  ];

  let salariesPrev = 100;
  let providentPrev = 100;
  let welfarePrev = 100;

  let salariesCurr = 50;
  let providentCurr = 50;
  let welfareCurr = 50;

  let totalPrev = (salariesPrev + providentPrev + welfarePrev).toFixed(1);
  let totalCurr = (salariesCurr + providentCurr + welfareCurr).toFixed(1);

  let spendData = [
    { year: "FY 2020 21", value: "0.0" },
    { year: "FY 2021 22", value: totalPrev },
    { year: "FY 2022 23", value: totalCurr },
  ];

  let legends = [
    { label: "Salaries, Wages & Bonus", color: THEME_COLORS.green },
    { label: "Provident & Other Funds", color: THEME_COLORS.yellow },
    { label: "Staff Welfare Expenses", color: THEME_COLORS.darkblue },
  ];

  if (activeDashboard === "live" && comp?.data && Array.isArray(comp.data)) {
    const getCategoryName = (d) =>
      d.category || d.investment_categories || d.name || "";

    const salaries =
      comp.data.find((d) =>
        getCategoryName(d).toLowerCase().includes("salaries"),
      ) || {};
    const provident =
      comp.data.find((d) =>
        getCategoryName(d).toLowerCase().includes("provident"),
      ) || {};
    const welfare =
      comp.data.find((d) =>
        getCategoryName(d).toLowerCase().includes("welfare"),
      ) || {};

    const getVal = (obj, isCurrent) => {
      if (isCurrent) {
        return obj.currentYear !== undefined
          ? obj.currentYear
          : obj.current_year !== undefined
            ? obj.current_year
            : 0;
      } else {
        return obj.previousYear !== undefined
          ? obj.previousYear
          : obj.previous_year !== undefined
            ? obj.previous_year
            : 0;
      }
    };

    salariesPrev = getVal(salaries, false);
    salariesCurr = getVal(salaries, true);
    providentPrev = getVal(provident, false);
    providentCurr = getVal(provident, true);
    welfarePrev = getVal(welfare, false);
    welfareCurr = getVal(welfare, true);

    totalPrev = (salariesPrev + providentPrev + welfarePrev).toFixed(1);
    totalCurr = (salariesCurr + providentCurr + welfareCurr).toFixed(1);

    spendData = [
      { year: "FY 2020 21", value: "0.0" },
      { year: "FY 2021 22", value: totalPrev },
      { year: "FY 2022 23", value: totalCurr },
    ];

    chartData = [
      { data: [salariesPrev, salariesCurr] },
      { data: [providentPrev, providentCurr] },
      { data: [welfarePrev, welfareCurr] },
    ];
  }

  return (
    <div className="pl-4 pr-4 pb-2">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <TitleImage className="w-13 h-13" />
          <div style={{ color: THEME_COLORS.green }}>
            <p className="text-[18px] sm:text-[20px] font-[Calibri] font-bold tracking-normal leading-tight m-0">
              Employee well-being
            </p>
            <p className="text-xs text-gray-500 font-normal leading-tight m-0 mt-1">
              Expenditure on salaries, wages, provident funds, and staff welfare
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full">
        {/* Right Section (Graph) */}
        <div className="-mt-2 w-full pr-4">
          <TwoBarHorizontalGraph
            data={chartData}
            categories={chartCategories}
            colors={chartColors}
            barNames={chartBarNames}
            showVerticaldata={true}
            showDataLabels={true}
            xAxisBorderColor="#000"
            hideHorizontalLines={true}
            height={410}
            tooltip={{
              shared: false,
              intersect: true,
              x: {
                show: true,
              },
              y: {
                formatter: function (val) {
                  return val;
                },
                title: {
                  formatter: function (seriesName) {
                    return seriesName + ": ";
                  },
                },
              },
            }}
          />
        </div>

        {/* Legends in 1 line at the bottom */}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 mt-4 pb-4">
          {legends.map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded"
                style={{ backgroundColor: item.color }}
              />
              <span
                className="text-[11px] sm:text-[12px] font-medium"
                style={{ color: THEME_COLORS.green }}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmployeeWellBeing;
